import { buildIdeariaHeaders } from "./identity-header";
import { getStoredUser, requestAuthentication } from "./auth-api";

const API_BASE = (import.meta.env.VITE_OSTEOPATIA_SERVER ?? "http://localhost:5054").replace(/\/$/, "") + "/api";

export class ApiError extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
    this.name = "ApiError";
  }
}

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const user = getStoredUser();
  const headers = new Headers(init.headers);
  if (!(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (user?.token) headers.set("Authorization", "Bearer " + user.token);
  const tenantId = user?.permissions?.[0]?.fkTenant ?? user?.permissions?.[0]?.FkTenant;
  if (tenantId) headers.set("X-Tenant-Id", tenantId);

  const response = await fetch(API_BASE + path, { ...init, headers: await buildIdeariaHeaders(headers) });
  if (response.status === 401) requestAuthentication();

  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("application/json")) {
    if (!response.ok) {
      const message = (await response.text()) || response.statusText;
      throw new ApiError(response.status, message);
    }
    return (await response.blob()) as T;
  }

  const raw = await response.text();
  const data = raw ? JSON.parse(raw) : undefined;
  if (!response.ok) {
    const message = typeof data === "string"
      ? data
      : data?.message ?? data?.Message ?? data?.detail ?? JSON.stringify(data);
    throw new ApiError(response.status, message);
  }
  return data as T;
}

